import Page404 from '@/app/error-pages/404'
import { AppAbility } from '@/casl/ability'
import { AuthContext } from '@/context/auth/AuthContext'
import { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'


interface MyRouterContext {
  auth: AuthContext
  ability: AppAbility
  queryClient: QueryClient
}



export const Route = createRootRouteWithContext<MyRouterContext>()({
  notFoundComponent: () => {
    return <Page404 />
  },
  pendingComponent: () => {
    return <div className='absolute z-50 text-6xl text-red-500 top-0 left-0'>Loading...</div>
  },
  component: () => {
    return <Outlet />
  },
})